module.exports = __webpack_public_path__ + "media/images/contest/con-ok-icon-e75ff77e22ecba32b4efe1b0a1650112.svg";